module.exports = (numero, decimal) => {
  if (!decimal) decimal = 2
  let real = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: decimal, maximumFractionDigits: decimal }).format(numero)
  real = real.replace(/\s/g, '')
  real = real.replace('R$', '')
  return real
}